var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_container"},[_c('p',[_vm._v("Génération en cours")]),_c('p',[_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin","font-scale":"4"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }